// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE
'use strict';

var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

function handleLogout() {
  localStorage.removeItem("start_date_timestamp");
  localStorage.removeItem("wizard_result");
  localStorage.removeItem("levels");
  localStorage.removeItem("points");
  localStorage.removeItem("reps");
  localStorage.removeItem("completed");
  localStorage.removeItem("bonus_done");
  localStorage.removeItem("food_plan");
  localStorage.removeItem("access_token");
  localStorage.removeItem("all_token_data");
  localStorage.removeItem("expires_in");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("token_timestamp");
  localStorage.removeItem("token_expires_at");
  localStorage.removeItem("errortest");
  localStorage.removeItem("email");
  localStorage.removeItem("network_sync_status");
  return ReasonReact.Router[/* push */0]("/login");
}

exports.handleLogout = handleLogout;
/* ReasonReact Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/supportFuncs.re
// module id = 50
// module chunks = 0